import posthog from "posthog-js";
import type { AnyRouter } from "@tanstack/react-router";
import { isAnalyticsReady, silently } from "./analytics";

/** The super-admin panel is excluded from analytics. */
const isAdminRoute = (routeId: string): boolean =>
  routeId.startsWith("/_authed/$companySlug/admin");

let lastPathname: string | undefined;

/**
 * Sends `$pageview` once per new pathname after a navigation resolved (a change
 * in search params alone is not a new page). `route` is the leaf route pattern,
 * e.g. `/_authed/$companySlug/tenders/$tenderId/`, so pageviews group by screen
 * rather than by URL.
 */
export const trackPageviews = (router: AnyRouter): void =>
  silently(() => {
    router.subscribe("onResolved", (event) =>
      silently(() => {
        if (!isAnalyticsReady()) return;

        const pathname = event?.toLocation?.pathname;
        if (!pathname || pathname === lastPathname) return;
        lastPathname = pathname;

        const route = router.state?.matches?.at(-1)?.routeId;
        if (!route || isAdminRoute(route)) return;

        posthog.capture("$pageview", { route });
      }),
    );
  });
